import { getUser } from "@/components/session/JwtTokenManager";
import { FullMeeting } from "@/types/meetings";

export function canManageGuests(meeting: FullMeeting) {
  const user = getUser();

  if (meeting?.canceledAt) {
    return false;
  }

  if (user?.isStaff || user?.isSuperuser) {
    return true;
  }

  if (user?.id === meeting?.coach?.id || user?.id === meeting?.customer?.id) {
    return true;
  }

  return false;
}

export function canToggleAllowGuests(meeting: FullMeeting) {
  const user = getUser();
  if (meeting?.canceledAt) {
    return false;
  }

  if (user?.isStaff || user?.isSuperuser) {
    return true;
  }

  if (user?.id === meeting?.coach?.id) {
    return true;
  }

  return false;
}
